import { useState, useEffect } from 'react';
import { TrendingUp } from 'lucide-react';

interface ScoreFilterProps {
  minScore: number | undefined;
  maxScore: number | undefined;
  onChange: (minScore: number | undefined, maxScore: number | undefined) => void;
}

const SCORE_PRESETS = [
  { label: 'All Scores', min: undefined, max: undefined },
  { label: 'High (70+)', min: 70, max: undefined },
  { label: 'Medium (40-69)', min: 40, max: 69 },
  { label: 'Low (<40)', min: undefined, max: 39 },
];

export function ScoreFilter({ minScore, maxScore, onChange }: ScoreFilterProps) {
  const [activePreset, setActivePreset] = useState<number | null>(null);

  // Determine active preset based on current values
  useEffect(() => {
    const presetIndex = SCORE_PRESETS.findIndex(
      (p) => p.min === minScore && p.max === maxScore
    );
    setActivePreset(presetIndex >= 0 ? presetIndex : null);
  }, [minScore, maxScore]);

  const handlePresetClick = (index: number) => {
    const preset = SCORE_PRESETS[index];
    if (preset) {
      onChange(preset.min, preset.max);
    }
  };

  return (
    <div>
      <label className="flex items-center gap-2 text-sm font-medium text-font-primary mb-2">
        <TrendingUp className="w-4 h-4" />
        Lead Score
      </label>
      <div className="flex flex-wrap gap-2">
        {SCORE_PRESETS.map((preset, index) => (
          <button
            key={preset.label}
            onClick={() => handlePresetClick(index)}
            className={`px-3 py-1.5 text-sm rounded-full border transition-colors ${
              activePreset === index
                ? 'bg-brand-primary text-white border-brand-primary'
                : 'bg-white text-font-secondary border-card-border hover:border-brand-primary'
            }`}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
}
